import * as o2Api from "../api";

export const getErestSimpleStockList = async (params) => {
  try {
    const { data: result } = await o2Api.getErestSimpleStockList(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    }
    else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};
